export function safeParseJSON(json, defaultValue) {
  if (!json) {
    return defaultValue;
  }
  try {
    return JSON.parse(json);
  } catch (_unused) {
    return defaultValue;
  }
}